module.exports = __webpack_public_path__ + "img/icon-graph.5cacd947.svg";